import { mdiAccountCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const AccountCircleOutlined = (props: IconProps) => {
    const { color, title, size = 1 } = props
    return (
        <Icon
            data-testid="Icon__AccountCircleOutlined"
            path={mdiAccountCircleOutline}
            title={title}
            size={size}
            color={color}
        />
    )
}

export default AccountCircleOutlined
